import { Table } from "@/components/elements/Table";
import { EMPTY_STR } from "@/constants/string";
import { useTable } from "@/hooks/useTable";
import { MRT_ColumnDef } from "material-react-table";
import React, { useMemo } from "react";
import { TGetCompanyOutputDto } from "@/api/services/main/company/dtos/get-company-list.dto";
import { useGetMainIndustryList } from "@/api/services/global/master";
import { typography } from "@/theme/typography";
import { divider } from "@/theme/colors";

type TCompanyAfterProps = {
  rows: TGetCompanyOutputDto[];
  isLoading: boolean;
};

export const CompanyAfterImport = ({ rows, isLoading }: TCompanyAfterProps) => {
  const { mainIndustryOptions } = useGetMainIndustryList();

  const _ItemCell = (firstLabel: string | null | undefined, secondLabel: string | null | undefined) => {
    const isEmpty = !firstLabel && !secondLabel;

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        {isEmpty ? (
          <p style={typography.body14}>{EMPTY_STR.TEXT}</p>
        ) : (
          <>
            <p style={typography.body14}>{firstLabel ?? ""}</p>
            <p style={typography.cap12}>{secondLabel ?? ""}</p>
          </>
        )}
      </div>
    );
  };

  const columns = useMemo<MRT_ColumnDef<TGetCompanyOutputDto>[]>(
    () => [],
    [mainIndustryOptions],
  );

  const { table } = useTable({ columns, rows });

  return <Table table={table} isLoading={isLoading} borderColor={divider.high} height="calc(100vh - 620px)" />;
};
